import { useLocation, useNavigate } from "react-router-dom";
import { Col, Row } from "antd";
import dayjs from "dayjs";
import userDefault from "../../assets/images/user-default.svg";
import "./UserBar.css";
import config from "../../utils/config";

function UserBar({ user }) {
  const location = useLocation();

  const navigate = useNavigate();

  return (
    <>
      {location.pathname !== "/profile" && location.pathname !== "/adminProfile" && (
        <div className="user_bar w-full flex flex-col lg:flex-row justify-between flex-wrap lg:flex-nowrap w-full items-center">
          <div className="mb-[20px] flex flex-wrap lg:flex-nowrap justify-center lg:justify-start">
            {user?.img ? (
              <div
                className="img-perfil mr-0 lg:mr-6"
                style={{
                  backgroundImage: `url(${config.server_ip}media/${user?.img})`,
                }}
              ></div>
            ) : (
              <img src={userDefault} className="w-full mr-0 lg:mr-6 max-w-[200px]" />
            )}
            <div className="info_user mt-4 lg:mt-0">
              <p className="text-[20px] text-[#BDBCBC] text-center lg:text-left">Bem-vindo</p>
              <p className="text-[34px] font-[600] text-[#4A4C4D] mt-4 mb-4 leading-none text-center lg:text-left">{user?.name}</p>
              <p className="text-[#4A4C4D] text-[18px] text-center lg:text-left">
                {!user?.is_admin && !user?.is_viewer ? user?.profession_name : user?.is_admin ? "Administrador" : "Viewer"}
              </p>
              <div className="edit_profile flex items-center justify-center lg:justify-start">
                <p>Editar perfil</p>
                <div className="icon" onClick={() => navigate(`/${user?.is_admin || user?.is_viewer ? "adminProfile" : "profile"}`)}></div>
              </div>
            </div>
          </div>
          <div className="flex flex-col items-center justify-center lg:justify-start">
            {!user?.is_admin && !user?.is_viewer && (
              <>
                <p className="mb-2 text-center text-[16px]">Nº de Associado</p>
                <div className="number">
                  <p className="text-[30px] font-bold">{user?.n_member ? user?.n_member : "-"}</p>
                </div>
              </>
            )}
            {!user?.is_admin && !user?.is_viewer && (
              <div className="flex flex-col mt-2">
                <p className="text-[11px] mb-2 text-center">Membro desde:</p>
                <p className="text-[18px] mt-0 text-center">{user?.member_since ? dayjs(user.member_since).format("DD-MM-YYYY") : ""}</p>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default UserBar;
